module.exports = __webpack_public_path__ + "img/footerLogo.01ac8438.png";